"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement("path", {
  d: "m23.19 10.29-1.92-1.54a1.18 1.18 0 0 1-.43-1l.27-2.45a2.17 2.17 0 0 0-2.39-2.39l-2.45.27a1.19 1.19 0 0 1-1-.43L13.69.79a2.23 2.23 0 0 0-3.38 0L8.77 2.71a1.18 1.18 0 0 1-1 .43l-2.49-.27a2.16 2.16 0 0 0-2.39 2.39l.27 2.45a1.18 1.18 0 0 1-.43 1L.81 10.29a2.17 2.17 0 0 0 0 3.38l1.92 1.54a1.18 1.18 0 0 1 .43 1l-.27 2.49a2.16 2.16 0 0 0 2.39 2.39l2.45-.27a1.18 1.18 0 0 1 1 .43l1.54 1.92a2.17 2.17 0 0 0 3.38 0l1.54-1.92a1.19 1.19 0 0 1 1-.43l2.45.27a2.16 2.16 0 0 0 2.39-2.39l-.27-2.45a1.18 1.18 0 0 1 .43-1l1.92-1.54a2.17 2.17 0 0 0 0-3.38Zm-6.48 5a1 1 0 0 1-1.42 1.42l-3.11-3.12a.25.25 0 0 0-.36 0l-3.11 3.1a1 1 0 0 1-1.42 0 1 1 0 0 1 0-1.42l3.12-3.11a.25.25 0 0 0 0-.36L7.29 8.69a1 1 0 1 1 1.42-1.42l3.11 3.12a.25.25 0 0 0 .36 0l3.11-3.12a1 1 0 1 1 1.42 1.42l-3.12 3.11a.25.25 0 0 0 0 .36Z"
}), 'RemoveBadge');

exports.default = _default;